import React from "react";
import replay from "./replay.svg";
import home from "./home.svg";

export interface props {
	showEndPlate: boolean;
	goToVideo: (id: string) => void;
}

export const EndComponent = ({ goToVideo, showEndPlate }: props) => {
	return (
		<div
			className={
				"intro-component position-fixed w-100 h-100 d-flex align-items-center black-bg " +
				(showEndPlate ? " " : "hide")
			}
		>
			<div className="container text-center">
				<div className="d-sm-inline-flex">
					<a
						href="https://ientyndtraad.dk"
						className="cursor-pointer button primary mb-4 mb-lg-0 mr-sm-5 p-3 px-5 d-inline-flex align-items-center"
					>
						<img
							draggable="false"
							className="mr-2"
							width="20"
							src={home}
							alt="Forside"
						/>{" "}
						Forside
					</a>
					<button
						className="cursor-pointer button primary mr-sm-5 p-3 px-5 d-inline-flex align-items-center"
						onClick={() => {
							goToVideo("video1-2");
						}}
					>
						<img
							draggable="false"
							className="mr-2"
							width="20"
							src={replay}
							alt="Forside"
						/>{" "}
						Start forfra
					</button>
				</div>
			</div>
		</div>
	);
};
